import './DefaultAvatar.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Icon from 'atoms/icon';
import { generateKey } from 'util';

export function DefaultAvatar({ size = 'big', animal, className, avatar }) {
  const getIcon = () => {
    const typeId = animal?.type.id;
    if (typeId === 1) return 'cat';
    if (typeId === 2) return 'dog';
    if (typeId === 3) return 'exotic';
    if (typeId === 4) return 'largeAnimal';
    if (typeId === 5) return 'pocketPet';
    return 'pawFilled';
  };

  const getIconSize = () => {
    if (size === 'extra-small') return 12;
    if (size === 'medium-small') return 16;
    if (size === 'small') return 20;
    if (size === 'medium') return 35;
    if (size === 'big') return 50;
    if (size === 'extra-large') return 80;
    return size || 50;
  };

  return (
    <div
      className={classNames(
        'default-avatar',
        `default-avatar--${size}`,
        className,
        avatar && 'default-avatar--transparent'
      )}
      style={{ backgroundImage: avatar ? `url(${avatar})` : '' }}
    >
      {!avatar && (
        <Icon
          key={generateKey()}
          name={getIcon()}
          style={{ width: getIconSize(), height: getIconSize() }}
        />
      )}
    </div>
  );
}

DefaultAvatar.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['extra-small', 'small', 'medium', 'big', 'extra-large']),
    PropTypes.number,
  ]),
  // We'll grab the animal type and display relevant icon if avatar isn't present
  animal: PropTypes.object,
  // Avatar URL
  avatar: PropTypes.string,
};
